/**
 * 配置的公共参数
 */
export default {
  baseUrl:
    process.env.VUE_APP_TITLE === "prod"
      ? {
          // 正式环境
          web: "https://school.api.yunc360.cn",
          login: "",
        }
      : process.env.VUE_APP_TITLE === "test"
      ? {
          // 测试环境
          web: "https://school.api.yunc360.cn",
          login: "",
        }
      : {
          // 本地环境
          web: "/testapi",
          login: "",
        },
};
